import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../../assets/styles/IndividualChickenView.module.scss';
import BackButton from '../../components/BackButton/BackButton';

interface Chicken {
    name: string;
    description: string;
    imageUrl: string;
}

const IndividualChickenView: React.FC = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const chicken = state as Chicken;

    if (!chicken) {
        return (
            <div className={styles.fallback}>
                <p>Chicken not found. Please return to the flock.</p>
                <BackButton to="/chickens" />
            </div>
        );
    }

    return (
        <div className={styles.profile}>
            <div className={styles.header}>
                <BackButton to="/chickens" />
                <h1 className={styles.name}>{chicken.name}</h1>
            </div>

            <div className={styles.imageContainer}>
                <img src={chicken.imageUrl} alt={chicken.name} className={styles.image} />
            </div>

            <div className={styles.descriptionBox}>
                <p className={styles.description}>{chicken.description}</p>
            </div>
        </div>
    );
};

export default IndividualChickenView;
